<template>
  <div class="button_box">
        <button class="back_btn" @click="back">返回</button>
      </div>
</template>

<script>
export default {
  name: "couponTabBox",
  components: {},
  data() {
    return {
    };
  },
  created() {
    
  },
  methods: {
    back(){
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
  .button_box{
  width:100%;
  margin-top:2.5rem;
  margin-bottom:1rem;
  text-align:center;
}
.back_btn{
  background-color:#45B9BC;
  color:white;
  border-radius:4px;
  padding:.5rem 5.5rem;
  font-size:1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/backButton.vue